/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type CartAdjustAutoshipMutationInput = {
    readonly autoShipIntervalCount?: number | null;
    readonly autoShipIntervalUnit?: string | null;
    readonly clientMutationId?: string | null;
};
export type CartAdjustAutoshipMutationVariables = {
    readonly input: CartAdjustAutoshipMutationInput;
};
export type CartAdjustAutoshipMutationResponse = {
    readonly cartAdjustAutoship: ({
        readonly cart: ({
            readonly id: string;
            readonly autoShipEnabled: boolean | null;
            readonly autoShipIntervalUnit: string | null;
            readonly autoShipIntervalCount: number | null;
            readonly enrollingAsPc: boolean | null;
        }) | null;
    }) | null;
};
export type CartAdjustAutoshipMutation = {
    readonly response: CartAdjustAutoshipMutationResponse;
    readonly variables: CartAdjustAutoshipMutationVariables;
};



/*
mutation CartAdjustAutoshipMutation(
  $input: CartAdjustAutoshipMutationInput!
) {
  cartAdjustAutoship(input: $input) {
    cart {
      id
      autoShipEnabled
      autoShipIntervalUnit
      autoShipIntervalCount
      enrollingAsPc
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "CartAdjustAutoshipMutationInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "cartAdjustAutoship",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input",
                    "type": "CartAdjustAutoshipMutationInput!"
                }
            ],
            "concreteType": "CartAdjustAutoshipMutationPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "cart",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Cart",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "id",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "autoShipEnabled",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "autoShipIntervalUnit",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "autoShipIntervalCount",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "enrollingAsPc",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "CartAdjustAutoshipMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "CartAdjustAutoshipMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "CartAdjustAutoshipMutation",
            "id": null,
            "text": "mutation CartAdjustAutoshipMutation(\n  $input: CartAdjustAutoshipMutationInput!\n) {\n  cartAdjustAutoship(input: $input) {\n    cart {\n      id\n      autoShipEnabled\n      autoShipIntervalUnit\n      autoShipIntervalCount\n      enrollingAsPc\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'a42300815cbca7ab7a5d82e537a3945d';
export default node;
